import { ReactElement } from 'react';
import { spacingHelper } from '@rea-group/construct-kit-core';
import styled from 'styled-components';

type RCALogoProps = {
  trackLinkClickThrough: (element: string) => void;
};

const CLICK_THROUGH_ELEMENT = 'header:home';

const LogoLink = styled.a`
  display: inline-block;
  align-items: center;
  font-size: 0;
  flex-shrink: 1;
  margin-right: ${spacingHelper('small')};

  ${({ theme }) => theme.layoutBreakpoints.medium} {
    margin-right: ${spacingHelper('twoExtraLarge')};
  }
`;

const Image = styled.img`
  max-width: none;
  width: 8.25rem;
  height: 1.5rem;

  ${({ theme }) => theme.layoutBreakpoints.extraLarge} {
    width: 13.75rem;
    height: 2.5rem;
  }
`;

const Logo = ({ trackLinkClickThrough }: RCALogoProps): ReactElement => {
  return (
    <LogoLink
      href="/"
      onClick={() => trackLinkClickThrough(CLICK_THROUGH_ELEMENT)}
    >
      <Image
        src="https://www.realcommercial.com.au/listing-ui-assets/img/rca-logo-black-v3.svg"
        alt="realcommercial.com.au logo"
        title="Commercial property for sale and lease"
      />
    </LogoLink>
  );
};

export default Logo;
